import React from 'react';
import IconInstagram from './IconInstagram';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconIstagramSave: React.FC<IconProps> = ({ width = 25, height = 21, color = '#000' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 25 21"
            fill="none"
        >
            <path
                d="M19.8476 19.9951C19.6839 19.9943 19.5253 19.9442 19.3977 19.8532L12.5913 15.0157L5.79215 19.8532C5.68552 19.9301 5.55652 19.9785 5.42015 19.9928C5.28379 20.0072 5.14565 19.9868 5.02178 19.9341C4.89792 19.8814 4.79342 19.7986 4.72042 19.6952C4.64741 19.5918 4.60891 19.4722 4.60938 19.3501V1.29002C4.60938 1.11896 4.68583 0.954898 4.82191 0.833936C4.95799 0.712975 5.14256 0.64502 5.33501 0.64502H19.8476C20.04 0.64502 20.2246 0.712975 20.3607 0.833936C20.4967 0.954898 20.5732 1.11896 20.5732 1.29002V19.3501C20.5728 19.4717 20.5338 19.5907 20.4606 19.6934C20.3874 19.7961 20.2831 19.8783 20.1596 19.9306C20.0631 19.9745 19.956 19.9967 19.8476 19.9951ZM12.5913 13.5451C12.7575 13.5445 12.9188 13.5945 13.0484 13.687L19.1219 18.0085V1.93502H6.06064V18.0085L12.1414 13.687C12.2691 13.5959 12.4276 13.5459 12.5913 13.5451Z"
                fill={color}
            />
        </svg>
    );
};

export default IconIstagramSave;
